if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.mediaGallery = this.querySelector('media-gallery');
      this.handleMediaQueryChange = this.onMediaQueryChange.bind(this);
    }

    hide() {
      super.hide();
      this.classList.remove('is-open');
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();

      setTimeout(() => {
        this.classList.add('is-open');
      }, 100);
    }

    onMediaQueryChange() {
      if (this.mql.matches) {
        this.buildTimeline();
      } else {
        this.hide();
      }
    }

    showActiveMedia() {
      const activeMediaId = this.openedBy.getAttribute("data-media-id");
      const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      this.mediaGallery.setActiveMedia(`${this.sectionId}-${activeMediaId}`, false);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
